import {_addToEventLog, forceAppUpdate} from '../app/app'
import Config from '../launch/config'
import Effects from '../effects/effects'
import ArcTimer from '../arc-timer/arc-timer'
import {saveGame} from '../launch/store'
import audio from '../launch/audio'

const handleMineClick = (entity) => {
    if (!entity) {
        return
    }

    const {x, y} = entity
    const difficulty = Config.difficultyLevels[Config.difficulty]

    entity.isBuildingMine = true
    entity.statusLabel.setText('Building')

    Config.gameStats.resources -= difficulty.planetMineResourceCost

    new Effects().resourceAnim({
        x,
        y,
        num: difficulty.planetMineResourceCost,
        positive: false,
    })

    forceAppUpdate()

    const arc = new ArcTimer({
        color: Config.colorGreen,
        duration: difficulty.planetMineBuildTime,
        radius: entity.diameter + 2,
        reverse: true,
        x,
        y,
    })

    arc.promise.then(() => {
        Config.gameStats.score += difficulty.planetMineBuildPoints
        new Effects().scoreAnim({
            x,
            y,
            num: difficulty.planetMineBuildPoints,
            positive: true,
        })

        entity.statusLabel.setText('')
        entity.isMiningResources = true
        entity.isBuildingMine = false

        _addToEventLog({
            html: `The planet <span style="color: #${Config.colorGreen}">${entity.name}</span> is now producing resources`,
            coords: {x, y},
        })
        audio.mine()
        forceAppUpdate()
        saveGame('handleMineClick')
    })
}

export default handleMineClick
